import { createServerFn } from "@tanstack/react-start";
import { sanityClient, type GeoResource } from "./sanity";

const GEO_RESOURCE_PROJECTION = `{
  _id, _updatedAt, title, excerpt, category, readTime, publishedAt, externalUrl, slug,
  coverImage{ asset->{ url, metadata { dimensions } } }
}`;

export const getLatestGeoResources = createServerFn({ method: "GET" }).handler(
  async (): Promise<GeoResource[]> => {
    try {
      const results = await sanityClient.fetch<GeoResource[]>(
        `*[_type == "geoResource"] | order(order asc, publishedAt desc)[0...3]${GEO_RESOURCE_PROJECTION}`,
      );
      return results ?? [];
    } catch (err) {
      console.error("Sanity fetch failed (geoResource):", err);
      return [];
    }
  },
);
